import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchTreatmentTypesOld = async () => {
  const token = localStorage.getItem("token");

  const response = await axios.get(`${__API_URL__}/api/cms/treatment_types_old/`, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return response.data;
};

const useGetTreatmentTypesOld = ({ enabled = true } = {}) => {
  return useQuery({
    queryKey: ["treatment_types_old"],
    queryFn: fetchTreatmentTypesOld,
    enabled,
  });
};

export default useGetTreatmentTypesOld;
